
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"71.3","height":"51.7","viewBox":"0 0 71.3 51.7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M65.1 17a1.685 1.685 0 00-1.7 1.7v11.1h-4.2v-4.9a7.277 7.277 0 00-7.3-7.3h-3.8a3.311 3.311 0 01-3.4-3.4 3.458 3.458 0 00-3.4-3.5h-4.8v-4H43A1.685 1.685 0 0044.7 5V1.7A1.685 1.685 0 0043 0H17.4a1.685 1.685 0 00-1.7 1.7V5a1.685 1.685 0 001.7 1.7h5.9v4H18a7.277 7.277 0 00-7.3 7.3v4.5h-4v-6.8A1.685 1.685 0 005 14H1.7A1.685 1.685 0 000 15.7v24.1a1.685 1.685 0 001.7 1.7H5a1.685 1.685 0 001.7-1.7v-8.9h4v6.6a7.277 7.277 0 007.3 7.3h8.7a3.311 3.311 0 013.4 3.4 3.458 3.458 0 003.4 3.5h18.3a7.277 7.277 0 007.3-7.3v-6.1h4.2v11.1a1.685 1.685 0 001.7 1.7 6.274 6.274 0 006.3-6.3V23.2a6.231 6.231 0 00-6.2-6.2z"}})])
          )
        }
      }
    